export const ROUTE_PATH = {
  MAIN: '/mobility-bonus/main',
  DASHBOARD: '/mobility-bonus/dashboard',
  INTRO: '/mobility-bonus/intro',
  BRIDGE: '/mobility-bonus/bridge',
}
